import React from 'react'

function Banner() {
    return (
        <div className="w-100"
            style={{ backgroundImage: 'url(banner/baner-top.jpg)', height: '300px', backgroundPosition: 'center center', backgroundSize: 'cover' }}>
        </div>
    )
}

export default Banner